import React, { FC, useState } from "react"
import { observer } from "mobx-react"
import { Form, Input, Modal, Select } from "antd"
import { useStore } from "stores/utils/use-store"
import { GameMode as GameModeType } from "domains/games/store/types"
import { SubmitCancelButtons } from "components"
import { GAMEMODE_PARAMETER_PRESETS, isPresetGamemodeParameter } from "abstract/constants/gamemode-parameter"

type GameModeProps = {
  onClose: () => void;
  editType: "create" | "edit";
  gameId: string;
};

export const GameMode: FC<GameModeProps> = observer(({ onClose, editType, gameId }) => {
  const {
    dataStore: {
      gamesStore,
      gamesStore: {
        selectedGameMode,
        selectedGameMode: { name, pretyName, id, gameModeParameter },
      },
    },
  } = useStore()
  const [form] = Form.useForm()
  const [parameterType, setParameterType] = useState<"preset" | "custom">(
    gameModeParameter && isPresetGamemodeParameter(gameModeParameter) ? "preset" : "custom",
  )

  const onFinishHandler = async(event: GameModeType & { gameModeParameter?: string }) => {
    const dataToBack = {
      ...selectedGameMode,
      name: event.name,
      pretyName: event.pretyName,
      gameModeParameter: event.gameModeParameter || "gameMode",
      gameId,
    }

    editType === "edit"
      ? await gamesStore.updateGameMode({ ...dataToBack, modeId: id })
      : await gamesStore.createGameMode(dataToBack)
    onClose()
    await gamesStore.getData()
  }

  return (
    <Modal
      style={{ top: "10px" }}
      visible
      title={editType === "edit" ? "Edit game mode" : "Create game mode"}
      footer={null}
      onCancel={onClose}
      width="700px"
    >
      <Form onFinish={onFinishHandler} form={form}>
        <Form.Item
          label="Name"
          name="name"
          initialValue={name}
          rules={[
            {
              required: true,
              message: "Input name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Pretty name"
          name="pretyName"
          initialValue={pretyName}
          rules={[
            {
              required: true,
              message: "Input pretty name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Gamemode Parameter Type"
        >
          <Select
            value={parameterType}
            onChange={value => {
              setParameterType(value)
              form.setFieldsValue({ gameModeParameter: value ? GAMEMODE_PARAMETER_PRESETS[0] : "" })
            }}
          >
            <Select.Option value="preset">Preset</Select.Option>
            <Select.Option value="custom">Custom</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Gamemode Parameter"
          name="gameModeParameter"
          initialValue={gameModeParameter || "gameMode"}
          rules={[
            {
              required: true,
              message: "Input gamemode parameter!",
            },
          ]}
        >
          {parameterType === "preset" ? (
            <Select>
              {GAMEMODE_PARAMETER_PRESETS.map(p => (
                <Select.Option key={p} value={p}>{p}</Select.Option>
              ))}
            </Select>
          ) : (
            <Input placeholder="Enter custom parameter name" />
          )}
        </Form.Item>
        <SubmitCancelButtons onClose={onClose} isLoading={gamesStore.isLoading} />
      </Form>
    </Modal>
  )
})
